import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Generator from './pages/Generator';
import Login from './pages/Login';
import Register from './pages/Register';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import './App.css';

// ホームページコンポーネント
const Home = () => (
  <div className="home-container">
    <h1>AI職人くん</h1>
    <p className="subtitle">店舗業種に特化したSNSコンテンツ生成AIサービス</p>
    <div className="features">
      <div className="feature">
        <h2>簡単操作</h2>
        <p>店舗情報と写真をアップロードするだけで、魅力的な投稿文を自動生成します。</p>
      </div>
      <div className="feature">
        <h2>業種別最適化</h2>
        <p>飲食店、美容室、小売店など、業種に合わせた投稿文を生成します。</p>
      </div>
      <div className="feature">
        <h2>複数バリエーション</h2>
        <p>1回の生成で複数の投稿文候補から選べます。</p>
      </div>
    </div>
    <a href="/generator" className="cta-button">投稿文を生成する</a>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <header className="app-header">
            <div className="logo">AI職人くん</div>
            <nav className="nav-menu">
              <a href="/" className="nav-link">ホーム</a>
              <a href="/generator" className="nav-link">投稿生成</a>
              <a href="/login" className="nav-link">ログイン</a>
              <a href="/register" className="nav-link">会員登録</a>
            </nav>
          </header>
          
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/generator" element={
                <PrivateRoute>
                  <Generator />
                </PrivateRoute>
              } />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
            </Routes>
          </main>
          
          <footer className="app-footer">
            <p>&copy; 2025 AI職人くん - 店舗業種に特化したSNSコンテンツ生成AIサービス</p>
          </footer>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
